import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from './Toast';

import { useToast } from '@/hooks/use-toast';

// variant별 duration 정책: destructive는 5초, 나머지는 Provider 기본값(3초) 사용
export const getToastDuration = (variant: string | null | undefined): number | undefined => {
  return variant === 'destructive' ? 5000 : undefined;
};

export const Toaster = () => {
  const { toasts } = useToast();

  return (
    <ToastProvider duration={3000}>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props} duration={getToastDuration(props.variant)}>
            <div className="grid gap-1 w-full">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
};
